import { gql } from '@apollo/client';

export const GET_USER_SETTING = gql`
  query getUserSetting($userId: ID!, $settingSlug: String!) {
    getUserSetting(userId: $userId, settingSlug: $settingSlug) {
      value
    }
  }
`;
